import cn from 'classnames';
import { FC } from 'react';

import styles from './ModalActions.module.scss';

interface IModalActionsProps {
  placement?: 'left' | 'space-between';
  direction?: 'column';
  padding?: 'none';
  align?: 'centre';
  margin?: 'medium';
}

export const ModalActions: FC<IModalActionsProps> = ({ children, placement, direction, padding, align, margin }) => {
  return (
    <div
      className={cn(styles.Container, {
        [styles.ContainerLeft]: placement === 'left',
        [styles.ContainerSpaceBetween]: placement === 'space-between',
        [styles.ContainerColumn]: direction === 'column',
        [styles.PaddingNone]: padding === 'none',
        [styles.ContainerAlignCentre]: align === 'centre',
        [styles.ContainerMarginMedium]: margin === 'medium',
      })}
    >
      {children}
    </div>
  );
};
